import { type Dispatch } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { type IdontomatData } from "@src/api/useCloseSession";
import { getMaxDateForBirth } from "@src/helpers";

export interface TData {
  isManual?: boolean;
  guid: string;
  apiKey: string;
  lastActionTime: number;
  identomat: {
    frameUrl: string;
    skipKycSession: boolean;
    sessionId: string;
  };
  expectedTransactionTypes: number[];
  expectedTransactionsOther: string;
  closeSession: IdontomatData;
  citizenship: {
    birthCountry: number;
    passportCountry: number;
    birthCity: string;
    otherCountry: number;
    nonCitizen: boolean;
  };
  address: {
    legalCountry: number;
    legalCity: string;
    legalAddress: string;
    check: boolean;
    factCountryID: number;
    factCity: string;
    factAddress: string;
  };
  employment: {
    type: string;
    employer: string;
    workPosition: string;
    worktypes: string[];
    bussinessType: string;
    entrepreneurDetails: string;
    legalName: string;
    legalIdentificationNumber: string;
    legalWorkType: string;
    entrepreneurDetailsOther: string;
    legalWorkTypeOther: string;
  };
  pep: {
    type: string;
    pepName: string;
    pepSurname: string;
    pepWorkingPosition: string;
    pepRelation: string;
  };
  expectedTurnoverCode: string;
  monthlyIncomeCode: string;
  sourceOfIncomeCode: string;
  sourceOfIncomeOther: string;
  sourceOfIncomeCodes: string[];
  dialCode: string;
  phone: string;
  errorMessage: string;
  contextId: string;
}

export interface DataTypes {
  data: TData;
  setData: Dispatch<TData>;
  clearData: Dispatch<void>;
}

export const initial: TData = {
  isManual: false,
  guid: "",
  apiKey: "",
  lastActionTime: 0,
  identomat: {
    frameUrl: "",
    skipKycSession: false,
    sessionId: "",
  },

  expectedTransactionTypes: [],
  expectedTransactionsOther: "",
  closeSession: {
    firstName: "",
    lastName: "",
    birthDate: getMaxDateForBirth().toISOString(),
    expirationDate: new Date().toISOString(),
    sex: "male",
    nationality: "",
    issueDate: new Date().toISOString(),
    issueDateTime: new Date().toISOString(),
    authority: "",
    documentNumber: "",
    personalNumber: "",
    documentFrontSide: "",
    documentBackSide: "",
    documetType: "",
    selfImage: "",
    selfImages: [
      {
        imageName: "",
        imagePath: "",
        imageID: 0,
      },
    ],
    verified: false,
    status: "",
    countryID: 0,
    countryName: "",
    birthPlace: "",
    localFirstName: "",
    localLastName: "",
    legalAddress: "",
    legalCity: "",
    birthCountryId: 0,
    legalCountryID: 0,
    faceImage: "",
    citizenship: "",
  },
  citizenship: {
    birthCountry: 0,
    passportCountry: 0,
    birthCity: "",
    otherCountry: 0,
    nonCitizen: false,
  },
  address: {
    legalCountry: 0,
    legalCity: "",
    legalAddress: "",
    check: false,
    factCountryID: 0,
    factCity: "",
    factAddress: "",
  },
  employment: {
    type: "",
    employer: "",
    workPosition: "",
    worktypes: [],
    bussinessType: "",
    entrepreneurDetails: "",
    legalName: "",
    legalIdentificationNumber: "",
    legalWorkType: "",
    entrepreneurDetailsOther: "",
    legalWorkTypeOther: "",
  },
  pep: {
    type: "",
    pepName: "",
    pepSurname: "",
    pepWorkingPosition: "",
    pepRelation: "",
  },
  expectedTurnoverCode: "",
  monthlyIncomeCode: "",
  sourceOfIncomeCode: "",
  sourceOfIncomeCodes: [],
  sourceOfIncomeOther: "",
  dialCode: "995",
  phone: "",
  errorMessage: "",
  contextId: "",
};

const useZustandStore = create<DataTypes>()(
  persist(
    (set) => ({
      data: initial,
      setData: (data: TData) => {
        set(() => ({
          data: {
            ...data,
            lastActionTime: new Date().getTime(),
          },
        }));
      },
      clearData: () => {
        // eslint-disable-next-line no-console
        console.log("data cleared 111");
        set((data) => ({
          ...data,
          data: {
            ...initial,
            errorMessage: data.data.errorMessage,
          },
        }));
      },
    }),
    {
      name: "main_v3", // unique name
    }
  )
);

export default useZustandStore;
